import { useMutation } from 'react-query';
import { addReview } from 'services/product.service';

const useReviews = (link: string) => {
  const { mutate: submitReview, isLoading: submitting, isSuccess } = useMutation(
    (body: { name: string; stars: number; description: string }) => addReview(link, body),
  );

  return { submitReview, submitting, isSuccess };
};

export default useReviews;
